import React from 'react';
import CourseDetailTemplate from '../components/course/CourseDetailTemplate';
import { coursesData } from '../data/coursesData';
const Course3Page = () => {
  return <CourseDetailTemplate courseData={coursesData[3]} data-id="element-2272" />;
};
export default Course3Page;